/* ILIA tintzoeker
 * Getrouwe nabouw van de Octane AI-quiz op iliabeauty.com/pages/find-my-shade.
 *
 * Flow (gelijk aan .com, zonder verjaardag/e-mail/sms):
 *   1 huidtintgroep (9 foto's) → 2 precieze tint (foto's) → 3 huidtype → 4 huidproblemen
 *   (meerdere keuzes + Volgende) → 5 SPF → 6 dekking → 7 finish → laadscherm → resultaat.
 *
 * Matchlogica (gecontroleerd tegen .com met 1N–4N, 18N en 38C):
 *  - Tintnummer 1–42 = tintschaal van Skin Rewind Complexion Stick; per nummer hoort er
 *    één tint bij in elke complexion-formule (tabel SHADES).
 *  - De finish bepaalt de hoofdaanbeveling: dauwachtig → Super Serum Skin Tint,
 *    vervaagd → Skin Rewind Complexion Stick, gepolijst → True Skin Serum Foundation.
 *  - "Meer matches": concealer, foundation, stick, skin tint (vaste volgorde, zoals .com).
 *  - Varianten, beelden, prijzen en voorraad komen uit deze winkel. Is de gematchte tint
 *    uitverkocht, dan tonen we de dichtstbijzijnde leverbare tint uit dezelfde formule
 *    en zeggen we dat erbij.
 */
(() => {
  'use strict';

  /* [tintnummer, stickcode, skin tint-code, foundation-code, concealer-code] */
  const SHADES = [
    [1, '1N', 'ST.5', 'SF.25', '1N'], [2, '2C', 'ST1', 'SF.5', '2C'],
    [3, '3W', 'ST2', 'SF.5', '3W'], [4, '4N', 'ST2.5', 'SF.5', '5N'],
    [5, '5C', 'ST3', 'SF1', '6N'], [6, '6N', 'ST4', 'SF1', '7C'],
    [7, '7W', 'ST4', 'SF1.5', '8N'], [8, '8W', 'ST5', 'SF1.75', '9W'],
    [9, '9N', 'ST5', 'SF1.75', '9W'], [10, '10C', 'ST6.5', 'SF2', '10N'],
    [11, '11W', 'ST6', 'SF2', '11W'], [12, '12N', 'ST8', 'SF2', '12O'],
    [13, '13O', 'ST4', 'SF1.75', '12O'], [14, '14W', 'ST6', 'SF2.5', '11W'],
    [15, '15C', 'ST7', 'SF2', '13C'], [16, '16N', 'ST7', 'SF2.5', '12O'],
    [17, '17O', 'ST9', 'SF4.5', '14W'], [18, '18N', 'ST8', 'SF3', '15C'],
    [19, '19W', 'ST9.5', 'SF4', '16N'], [20, '20N', 'ST10', 'SF5', '16N'],
    [21, '21W', 'ST9', 'SF3.5', '17W'], [22, '22C', 'ST6.5', 'SF3', '16N'],
    [23, '23C', 'ST11', 'SF6', '19O'], [24, '24N', 'ST11.5', 'SF5', '18N'],
    [25, '25N', 'ST10', 'SF6.5', '20C'], [26, '26O', 'ST11.5', 'SF7', '19O'],
    [27, '27W', 'ST12', 'SF9', '20C'], [28, '28N', 'ST12.75', 'SF9.25', '23W'],
    [29, '29N', 'ST12.5', 'SF8.5', '22C'], [30, '30W', 'ST13.5', 'SF9.25', '23W'],
    [31, '31C', 'ST13', 'SF10', '22C'], [32, '32W', 'ST14', 'SF10.5', '25N'],
    [33, '33N', 'ST14.5', 'SF10.25', '25N'], [34, '34N', 'ST14', 'SF10.5', '25N'],
    [35, '35W', 'ST15', 'SF11', '27O'], [36, '36C', 'ST16', 'SF11', '27O'],
    [37, '37N', 'ST16.5', 'SF12', '28C'], [38, '38C', 'ST17', 'SF13.5', '29N'],
    [39, '39N', 'ST17.5', 'SF13.5', '29N'], [40, '40C', 'ST18', 'SF14', '31C'],
    [41, '41W', 'ST19', 'SF14', '32W'], [42, '42C', 'ST19', 'SF15', '34N']
  ];

  const GROUPS = [
    { label: 'Extra licht', from: 1, to: 4 },
    { label: 'Heel licht', from: 5, to: 8 },
    { label: 'Licht', from: 9, to: 12 },
    { label: 'Licht-medium', from: 13, to: 16 },
    { label: 'Medium', from: 17, to: 22 },
    { label: 'Medium-diep', from: 23, to: 27 },
    { label: 'Diep', from: 28, to: 32 },
    { label: 'Heel diep', from: 33, to: 37 },
    { label: 'Extra diep', from: 38, to: 42 }
  ];

  const UNDERTONE = { N: 'neutraal', C: 'koel', W: 'warm', O: 'olijf' };

  const FINISH_TO_KEY = { dauw: 'tint', vervaagd: 'stick', gepolijst: 'found' };
  const MORE_ORDER = ['blur', 'found', 'stick', 'tint'];

  const STEPS = [
    { id: 'groep', type: 'picture', vraag: 'Kies de huidtint die het meest op die van jou lijkt.' },
    { id: 'tint', type: 'picture', vraag: 'Nog even preciezer. Kies de huidtint die het meest op die van jou lijkt.' },
    {
      id: 'huidtype', type: 'single', vraag: 'Hoe voelt je huid meestal aan?',
      opties: [['droog', 'Droog'], ['vet', 'Vet'], ['combi', 'Een combinatie'], ['balans', 'Redelijk in balans']]
    },
    {
      id: 'wensen', type: 'multi', vraag: 'Welke huidproblemen wil je aanpakken?',
      opties: [['roodheid', 'Roodheid'], ['gevoeligheid', 'Gevoeligheid'], ['kringen', 'Donkere kringen'],
        ['textuur', 'Ongelijke textuur'], ['lijntjes', 'Fijne lijntjes + rimpels'], ['onzuiverheden', 'Onzuiverheden'],
        ['porien', 'Zichtbare poriën'], ['pigment', 'Hyperpigmentatie']]
    },
    {
      id: 'spf', type: 'single', vraag: 'Hoe belangrijk is SPF in je make-up?',
      opties: [['in', 'Ik wil SPF in mijn make-up'], ['apart', 'Ik gebruik SPF liever apart'], ['geen', 'Geen voorkeur']]
    },
    {
      id: 'dekking', type: 'single', vraag: 'Welke dekking zoek je?',
      opties: [['licht', 'Licht'], ['medium', 'Medium + opbouwbaar']]
    },
    {
      id: 'finish', type: 'single', vraag: 'Hoe wil je dat je huid eruitziet?',
      opties: [['dauw', 'Dauwachtig + fris'], ['vervaagd', 'Vervaagd + gewichtloos'], ['gepolijst', 'Gepolijst + zijdezacht']]
    }
  ];

  const REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
  ));

  const moneyFormat = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
  const money = (cents) => moneyFormat.format((Number(cents) || 0) / 100);

  /* Haalt de tintcode uit een varianttitel. "SF0.5" en "SF.5" zijn dezelfde tint. */
  function codeOf(key, title) {
    const t = String(title || '');
    if (key === 'tint' || key === 'found') {
      const p = key === 'tint' ? 'ST' : 'SF';
      const m = t.match(new RegExp('\\b' + p + '\\s*(\\d*\\.?\\d+)\\b', 'i'));
      return m ? p + m[1].replace(/^0(?=\.)/, '') : null;
    }
    const m = t.match(/\b(\d{1,2})\s*([NCWO])\b/i);
    return m ? m[1] + m[2].toUpperCase() : null;
  }

  function valueOf(code) {
    const m = String(code || '').match(/(\d*\.?\d+)/);
    return m ? parseFloat(m[1]) : NaN;
  }

  /* "SHELA ST8" → "Shela ST8", "2C BALSA" → "Balsa 2C", "Sable SF0.5" → "Sable SF.5" */
  function shadeName(key, variant) {
    const code = variant.code;
    if (!code) return variant.title;
    const rest = String(variant.title)
      .replace(key === 'tint' ? /\bST\s*\d*\.?\d+\b/i : key === 'found' ? /\bSF\s*\d*\.?\d+\b/i : /\b\d{1,2}\s*[NCWO]\b/i, '')
      .replace(/\s+/g, ' ').trim()
      .toLocaleLowerCase('nl-NL')
      .replace(/(^|[\s-])(\S)/g, (m, a, b) => a + b.toLocaleUpperCase('nl-NL'));
    return rest ? rest + ' ' + code : code;
  }

  function buildIndex(products) {
    const index = {};
    Object.keys(products).forEach((key) => {
      const p = products[key];
      index[key] = { product: p, byCode: {}, list: [] };
      (p.variants || []).forEach((v) => {
        const code = codeOf(key, v.title);
        const entry = Object.assign({}, v, { code: code, value: valueOf(code) });
        index[key].list.push(entry);
        if (code && !index[key].byCode[code]) index[key].byCode[code] = entry;
      });
    });
    return index;
  }

  function nearestAvailable(bucket, target) {
    let best = null;
    bucket.list.forEach((v) => {
      if (!v.available || !isFinite(v.value) || !isFinite(target)) return;
      if (!best || Math.abs(v.value - target) < Math.abs(best.value - target)) best = v;
    });
    return best;
  }

  /* De gematchte variant; is die uitverkocht (of niet in deze winkel), dan de
     dichtstbijzijnde leverbare tint uit dezelfde formule. */
  function resolve(index, key, code) {
    const bucket = index[key];
    if (!bucket) return null;
    const exact = bucket.byCode[code] || null;
    if (exact && exact.available) return { key, product: bucket.product, variant: exact, wanted: exact, swapped: false };
    const alt = nearestAvailable(bucket, valueOf(code));
    if (alt) return { key, product: bucket.product, variant: alt, wanted: exact, wantedCode: code, swapped: true };
    if (exact) return { key, product: bucket.product, variant: exact, wanted: exact, swapped: false };
    return null;
  }

  function codesFor(nr) {
    const r = SHADES.find((row) => row[0] === nr);
    return r ? { stick: r[1], tint: r[2], found: r[3], blur: r[4] } : null;
  }

  function variantUrl(product, variant) {
    const sep = product.url.indexOf('?') === -1 ? '?' : '&';
    return product.url + sep + 'variant=' + encodeURIComponent(variant.id);
  }

  /* Productbeeld per tint uit deze winkel. Bij de stick is het variantbeeld een
     voor/na-foto; de verpakkings- (_1) of swatchfoto (_2) van die tint staat in de
     productgalerij. */
  function imagesFor(match) {
    const p = match.product;
    const v = match.variant;
    if (match.key === 'stick' && v.code) {
      const find = (suffix) => (p.images || []).find((u) =>
        new RegExp('Stick-' + v.code + '[A-Za-z]+-\\d+_' + suffix + '(?:\\.|_)', 'i').test(u));
      const pack = find(1);
      const swatch = find(2);
      if (pack) return { main: pack, hover: swatch || v.image };
      if (swatch) return { main: swatch, hover: v.image };
    }
    return { main: v.image || p.image, hover: null };
  }

  function mediaImg(src, cls, eager) {
    if (!src) return '';
    return '<img class="' + cls + '" src="' + esc(src) + '" alt="" width="600" height="800"' +
      (eager ? '' : ' loading="lazy"') + ' decoding="async">';
  }

  async function request(endpoint, options) {
    const store = window.iliaStorefront;
    if (store && typeof store.request === 'function') return store.request(endpoint, options);
    const root = (document.body.dataset.iliaRoot || '/').replace(/\/?$/, '/');
    const response = await fetch(root + endpoint, Object.assign({}, options, {
      headers: Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, options && options.headers)
    }));
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'De winkelmand kon niet worden bijgewerkt. Probeer opnieuw.');
    return data;
  }

  /* ---------- de flow ---------- */

  function init(root) {
    const read = (sel) => {
      const node = root.querySelector(sel);
      if (!node) return null;
      try { return JSON.parse(node.textContent); } catch (e) { return null; }
    };
    const products = read('[data-isf-products]');
    const ritual = read('[data-isf-ritual]') || [];
    const images = read('[data-isf-images]') || {};
    if (!products) return;
    const usable = ['tint', 'stick', 'found', 'blur'].every((k) => products[k] && products[k].variants && products[k].variants.length);
    if (!usable) return;

    const index = buildIndex(products);
    const app = root.querySelector('[data-isf-app]');
    if (!app) return;
    root.querySelector('[data-isf-fallback]')?.setAttribute('hidden', '');
    root.querySelectorAll('[data-isf-static]').forEach((el) => { el.hidden = true; });
    app.hidden = false;

    const answers = {};
    let step = 0;
    let loaderTimer = null;
    let arrowNav = false;

    function optionsFor(def) {
      if (def.id === 'groep') {
        return GROUPS.map((g, i) => ({ id: String(i), label: g.label, img: images['g' + (i + 1)] }));
      }
      if (def.id === 'tint') {
        const g = GROUPS[parseInt(answers.groep, 10)] || GROUPS[0];
        const out = [];
        for (let n = g.from; n <= g.to; n += 1) {
          const c = codesFor(n).stick;
          out.push({ id: String(n), label: c + ' ' + g.label + ' — ' + UNDERTONE[c.slice(-1)], img: images['s' + c.toLowerCase()] });
        }
        return out;
      }
      return def.opties.map((o) => ({ id: o[0], label: o[1] }));
    }

    function shell(inner, opts) {
      const o = opts || {};
      return '<div class="isf-screen' + (o.cls ? ' ' + o.cls : '') + '">' +
        (o.back ? '<button type="button" class="isf-back" data-isf-back><span aria-hidden="true">&#8592;</span> Terug</button>' : '') +
        inner + '</div>';
    }

    function progress() {
      return '<div class="iv-visually-hidden" role="progressbar" aria-label="Voortgang tintzoeker" aria-valuemin="1" aria-valuemax="' +
        STEPS.length + '" aria-valuenow="' + (step + 1) + '" aria-valuetext="Vraag ' + (step + 1) + ' van ' + STEPS.length + '"></div>';
    }

    function renderStep(moveFocus) {
      clearTimeout(loaderTimer);
      const def = STEPS[step];
      const opts = optionsFor(def);
      const name = 'isf-' + def.id;
      const multi = def.type === 'multi';
      const picked = multi ? (answers[def.id] || []) : [answers[def.id]];
      const hintId = name + '-hint';

      const items = opts.map((o) => {
        const id = name + '-' + o.id;
        const checked = picked.indexOf(o.id) !== -1 ? ' checked' : '';
        const input = '<input class="isf-input" type="' + (multi ? 'checkbox' : 'radio') + '" id="' + esc(id) +
          '" name="' + esc(name) + '" value="' + esc(o.id) + '"' + checked + '>';
        if (def.type === 'picture') {
          return '<li class="isf-pic">' + input + '<label for="' + esc(id) + '">' +
            (o.img ? '<img src="' + esc(o.img) + '" alt="" width="600" height="800" decoding="async">' : '') +
            '<span class="iv-visually-hidden">' + esc(o.label) + '</span></label></li>';
        }
        return '<li class="isf-choice">' + input + '<label for="' + esc(id) + '">' + esc(o.label) + '</label></li>';
      }).join('');

      const listCls = def.type === 'picture'
        ? 'isf-pics isf-pics--' + (step === 0 ? 'groups' : 'n' + Math.min(opts.length, 5))
        : 'isf-choices';

      const hint = multi
        ? 'Kies een of meer antwoorden en ga daarna verder met Volgende.'
        : 'Kies een antwoord; je gaat meteen door naar de volgende vraag. Met het toetsenbord kies je met de pijltjestoetsen en ga je verder met Enter.';

      app.innerHTML = shell(
        progress() +
        '<form class="isf-form" novalidate data-isf-form>' +
          '<fieldset class="isf-fieldset" aria-describedby="' + hintId + '">' +
            '<legend class="isf-title" tabindex="-1" data-isf-focus>' + esc(def.vraag) + '</legend>' +
            '<p class="iv-visually-hidden" id="' + hintId + '">' + esc(hint) + '</p>' +
            '<ul class="' + listCls + '">' + items + '</ul>' +
          '</fieldset>' +
          (multi ? '<div class="isf-next-wrap"><button type="submit" class="isf-next"' + (picked.length ? '' : ' disabled') + '>Volgende</button></div>' : '') +
        '</form>',
        { back: step > 0, cls: 'isf-screen--' + def.type + (step === 0 ? ' isf-screen--first' : '') }
      );
      if (moveFocus) focusTarget();
    }

    function focusTarget() {
      const target = app.querySelector('[data-isf-focus]');
      if (!target) return;
      target.focus({ preventScroll: true });
      /* Zoals op .com: na elke stap staat de vraag bovenaan, met de navigatie nog net in beeld. */
      const offset = window.innerWidth >= 768 ? 93 : 70;
      const top = Math.max(0, app.getBoundingClientRect().top + window.scrollY - offset);
      if (Math.abs(window.scrollY - top) > 2) window.scrollTo({ top: top, behavior: 'auto' });
    }

    function advance() {
      if (step === STEPS.length - 1) renderLoader();
      else { step += 1; renderStep(true); }
    }

    function renderLoader() {
      app.innerHTML = shell(
        '<div class="isf-loader" role="status">' +
          '<p class="isf-title" tabindex="-1" data-isf-focus>We zoeken je tint&nbsp;…</p>' +
          '<span class="isf-drops" aria-hidden="true"><span></span><span></span><span></span><span></span></span>' +
        '</div>',
        { back: true, cls: 'isf-screen--loader' }
      );
      focusTarget();
      loaderTimer = setTimeout(renderResult, REDUCED ? 400 : 1800);
    }

    function badgeHtml(text) {
      return text ? '<span class="isf-badge">' + esc(text) + '</span>' : '';
    }

    function swapNote(match) {
      if (!match.swapped) return '';
      const wanted = match.wanted ? shadeName(match.key, match.wanted) : match.wantedCode;
      return 'Jouw tint ' + wanted + ' is tijdelijk uitverkocht. Dit is de dichtstbijzijnde tint die wel leverbaar is.';
    }

    function addButton(variant, cls, label) {
      if (!variant.available) {
        return '<button type="button" class="' + cls + '" disabled>Uitverkocht</button>';
      }
      return '<button type="button" class="' + cls + '" data-isf-add="' + esc(variant.id) + '" data-isf-label="' + esc(label) + '">' +
        '<span data-isf-add-text>In winkelmand</span> <span>' + esc(money(variant.price)) + '</span></button>';
    }

    function heroHtml(match) {
      const p = match.product;
      const v = match.variant;
      const url = variantUrl(p, v);
      const media = imagesFor(match);
      const shade = shadeName(match.key, v);
      const note = swapNote(match);
      return '<div class="isf-hero">' +
        '<div class="isf-hero-media"><a href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + mediaImg(media.main, 'isf-img', true) + '</a></div>' +
        '<div class="isf-hero-info"><div class="isf-hero-copy">' +
          '<h3 class="isf-hero-title"><a href="' + esc(url) + '">' + esc(p.title) + '</a></h3>' +
          (p.tagline ? '<p class="isf-hero-sub">' + esc(p.tagline) + '</p>' : '') +
          '<p class="isf-hero-shade">Tint: <strong>' + esc(shade) + '</strong></p>' +
          (note ? '<p class="isf-note">' + esc(note) + '</p>' : '') +
          addButton(v, 'isf-btn-outline', p.title + ' ' + shade) +
          '<p class="isf-add-status" role="status"></p>' +
        '</div></div>' +
      '</div>';
    }

    function cardHtml(card) {
      const url = card.url;
      const note = card.note ? '<p class="isf-card-note">' + esc(card.note) + '</p>' : '';
      return '<li class="isf-card">' +
        '<div class="isf-card-media"><a href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
          mediaImg(card.image, 'isf-img') + (card.hover ? mediaImg(card.hover, 'isf-img isf-img--hover') : '') +
        '</a>' + badgeHtml(card.badge) + '</div>' +
        '<div class="isf-card-body">' +
          '<h3 class="isf-card-title"><a href="' + esc(url) + '">' + esc(card.title) + '</a></h3>' +
          (card.tagline ? '<p class="isf-card-desc">' + esc(card.tagline) + '</p>' : '') +
          (card.shade ? '<p class="isf-card-shade">' + esc(card.shade) + '</p>' : '') +
          note +
        '</div>' +
        addButton(card.variant, 'isf-btn-solid', card.title + (card.shade ? ' ' + card.shade : '')) +
        '<p class="isf-add-status" role="status"></p>' +
      '</li>';
    }

    function renderResult() {
      clearTimeout(loaderTimer);
      const nr = parseInt(answers.tint, 10);
      const codes = codesFor(nr);
      if (!codes) { step = 0; renderStep(true); return; }
      const heroKey = FINISH_TO_KEY[answers.finish] || 'tint';
      const hero = resolve(index, heroKey, codes[heroKey]);
      if (!hero) { step = 0; renderStep(true); return; }

      const more = MORE_ORDER.map((k) => resolve(index, k, codes[k])).filter(Boolean).map((m) => {
        const media = imagesFor(m);
        return {
          url: variantUrl(m.product, m.variant), title: m.product.title, tagline: m.product.tagline,
          badge: m.product.badge, shade: shadeName(m.key, m.variant), variant: m.variant,
          image: media.main, hover: media.hover,
          note: m.swapped ? 'Jouw tint ' + (m.wanted ? shadeName(m.key, m.wanted) : m.wantedCode) + ' is uitverkocht' : ''
        };
      });

      const rituals = ritual.map((r) => ({
        url: r.url, title: r.title, tagline: r.tagline, badge: r.badge, shade: '',
        variant: r.variant, image: r.image, hover: r.hover
      }));

      app.innerHTML =
        '<div class="isf-result">' +
          '<section class="isf-match" aria-labelledby="isf-match-title">' +
            '<h2 class="isf-title isf-match-title" id="isf-match-title" tabindex="-1" data-isf-focus>Het is een match.</h2>' +
            heroHtml(hero) +
            '<p class="isf-guarantee">Past je tint toch niet? <a href="/pages/retourneren">Je kunt binnen 14 dagen retourneren.</a></p>' +
          '</section>' +
          '<section class="isf-block" aria-labelledby="isf-more-title">' +
            '<h2 class="isf-block-title" id="isf-more-title">Meer matches voor jou</h2>' +
            '<p class="isf-block-sub">Nu we toch bezig waren, vonden we ook je tint in de andere formules.</p>' +
            '<ul class="isf-cards isf-cards--4">' + more.map(cardHtml).join('') + '</ul>' +
          '</section>' +
          (rituals.length
            ? '<section class="isf-block isf-block--ritual" aria-labelledby="isf-ritual-title">' +
                '<h2 class="isf-block-title" id="isf-ritual-title">Bouw je ritueel</h2>' +
                '<p class="isf-block-sub">Je make-up is zo goed als je huidverzorging.</p>' +
                '<ul class="isf-cards isf-cards--' + rituals.length + '">' + rituals.map(cardHtml).join('') + '</ul>' +
              '</section>'
            : '') +
          '<div class="isf-restart-band"><button type="button" class="isf-restart" data-isf-restart>Opnieuw beginnen</button></div>' +
        '</div>';

      focusTarget();
    }

    async function addToCart(button) {
      const id = Number(button.dataset.isfAdd);
      if (!id || button.getAttribute('aria-busy') === 'true') return;
      const text = button.querySelector('[data-isf-add-text]');
      const status = button.parentElement.querySelector('.isf-add-status');
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      if (text) text.textContent = 'Toevoegen…';
      if (status) status.textContent = '';
      try {
        await request('cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) });
        const cart = await request('cart.js');
        const store = window.iliaStorefront;
        if (store && typeof store.renderCartContent === 'function') store.renderCartContent(cart).catch(() => {});
        else document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
        if (text) text.textContent = 'Toegevoegd';
        if (status) status.textContent = button.dataset.isfLabel + ' is toegevoegd aan je winkelmand.';
        if (store && typeof store.showCart === 'function' && document.getElementById('ilia-bag')) store.showCart(button);
        setTimeout(() => { if (text) text.textContent = 'In winkelmand'; }, 2500);
      } catch (error) {
        if (text) text.textContent = 'In winkelmand';
        if (status) status.textContent = error.message || 'Toevoegen is niet gelukt. Probeer opnieuw.';
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }

    /* Enkelvoudige keuze: klik/tik of Enter/spatie gaat door, pijltjes alleen kiezen. */
    app.addEventListener('keydown', (event) => {
      const input = event.target.closest('.isf-input');
      if (/^Arrow/.test(event.key) && input && input.type === 'radio') {
        arrowNav = true;
        setTimeout(() => { arrowNav = false; }, 0);
      }
      if (event.key === 'Enter' && input) {
        event.preventDefault();
        const def = STEPS[step];
        if (input.type === 'radio') {
          input.checked = true;
          answers[def.id] = input.value;
          if (def.id === 'groep') delete answers.tint;
          advance();
        } else {
          app.querySelector('.isf-next:not([disabled])')?.click();
        }
      }
    });

    app.addEventListener('click', (event) => {
      const input = event.target.closest('.isf-input');
      if (input && input.type === 'radio') {
        const def = STEPS[step];
        if (def.id === 'groep' && answers.groep !== input.value) delete answers.tint;
        answers[def.id] = input.value;
        if (arrowNav) return;
        setTimeout(advance, REDUCED ? 0 : 120);
        return;
      }
      if (event.target.closest('[data-isf-back]')) {
        if (app.querySelector('.isf-screen--loader')) { renderStep(true); return; }
        step = Math.max(0, step - 1);
        renderStep(true);
        return;
      }
      if (event.target.closest('[data-isf-restart]')) {
        Object.keys(answers).forEach((k) => delete answers[k]);
        step = 0;
        renderStep(true);
        return;
      }
      const add = event.target.closest('[data-isf-add]');
      if (add) addToCart(add);
    });

    app.addEventListener('change', (event) => {
      const input = event.target.closest('.isf-input');
      if (!input || input.type !== 'checkbox') return;
      const def = STEPS[step];
      answers[def.id] = [].slice.call(app.querySelectorAll('input[name="isf-' + def.id + '"]:checked')).map((i) => i.value);
      const next = app.querySelector('.isf-next');
      if (next) next.disabled = answers[def.id].length === 0;
    });

    app.addEventListener('submit', (event) => {
      event.preventDefault();
      const def = STEPS[step];
      if (def.type === 'multi' && (answers[def.id] || []).length) advance();
    });

    renderStep(false);
  }

  document.querySelectorAll('[data-shade-finder]').forEach(init);
})();
